"use strict";
/****************************************************
 * Audit Information Platform Component
 * 搜索参照项基类
 * 2020-08
 * Sunny <tufpsj@yonyou.com>
 ****************************************************/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
//----- Global ------
var React = require("react");
var react_1 = require("react");
/**
 * 基类提供每个参照项的基本处理例程和数据结构
 *
 * 参照的组件都是继承子 RefItem，如
 *
 * interface RadioRefProp extends RefItemProp {
 *   ...
 * }
 *
 * class RadioRef extends RefItem<RadioRefProp, any> {
 *   ...
 * }
 */
var RefItem = /** @class */ (function (_super) {
    __extends(RefItem, _super);
    function RefItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * 通知其他组件，子类直接调用，需要在托管组件的onChange中调用
         * @function
         * @param {string | null} value
         */
        _this.refItemValueChange = function (value) {
            _this.props.refItemValueChange && _this.props.refItemValueChange(_this.props.name, value);
            if (window.isAipDebug) {
                console.log("".concat(_this.props.name, " => ").concat(value));
            }
        };
        /**
         * 获取自己所依赖(不是驱动依赖，是参数依赖)的名字(参照.getName())数组
         * @function
         * @returns {string[]}
         */
        _this.getNeedFields = function () {
            return _this.props.needFields || [];
        };
        /**
         * 返回当前参照名称
         * @function
         * @returns {string}
         */
        _this.getName = function () {
            return _this.props.name;
        };
        /**
         * 返回当前参照显示标题(若没有设置，会返回getName()的值)
         * @function
         * @returns {string}
         */
        _this.getLabel = function () {
            return _this.props.label || _this.props.name;
        };
        /**
         * 清空操作，子类需要 **override**
         * @function
         */
        _this.clear = function () {
            _this.setState({ defaultValue: '', value: '' }, function () { });
        };
        /**
         * 获取数据的方法，会被调度系统触发 ** 每个子类必须实现 **
         *
         * 如果有`defaultValue`必须调用
         * ~~~javascript
         * // async or sync get load from remote or local
         * if (defaultValue) {
         *    // other code ...
         *    this.refItemValueChange(defaultValue);
         * }
         * @function
         * @param params 依赖的参数 StringStringMap 对象
         * @param defaultValue 默认值，可选的string参数，如果有默认值，需要在`loadData`后设置设置关联值，再调用`refItemValueChange`通知调度器
         */
        _this.loadData = function (params, defaultValue) {
            // not implements
        };
        /**
         * 获取组件选择/录入的返回值，按需 **override**
         * @function
         * @returns {string}
         */
        _this.getValue = function () {
            var result = _this.state.value || [];
            if (typeof (result) === 'string') {
                return result;
            }
            // Arrays
            if (_this.props.multiple === '1') {
                var tmp = result.map(function (item) {
                    return "'" + item + "'";
                });
                var t = tmp.join(',');
                return t;
            }
            else {
                var t = result.join(',');
                return t;
            }
        };
        /**
         * 设置组件的默认值(可以随时调用) **override**
         * 默认会赋值给 `state.value`
         * @function
         * @param {string} value
         */
        _this.setDefaultValue = function (value) {
            // not implement
            _this.setState({
                value: value,
            }, function () { });
        };
        return _this;
    }
    RefItem.prototype.render = function () {
        return React.createElement(React.Fragment, null);
    };
    return RefItem;
}(react_1.PureComponent));
exports.default = RefItem;
